import {
    AnalyticsOutlined, AttachEmailOutlined, BusinessOutlined,
    CampaignOutlined, CardMembershipOutlined,
    DashboardOutlined, EmailOutlined, EventRepeatOutlined,
    HelpCenterOutlined, LeaderboardOutlined, GroupOutlined,
    SubscriptionsRounded,
    SchemaRounded,
    //SettingsOutlined, 
} from "@mui/icons-material";
import { Box, Typography, useTheme } from "@mui/material";
import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';

import { Link, useLocation } from 'react-router-dom';

export default function SideNav({ collapsed, toggled, setToggled, isAdmin }) {
    const theme = useTheme();
    const location = useLocation();
    const menuItems = isAdmin ? [
        { path: "/home/admin", icon: <DashboardOutlined sx={{ ml: 2 }} />, label: "Dashboard" },
        { path: "/home/users", icon: <GroupOutlined sx={{ ml: 2 }} />, label: "Users" },
        { path: "/home/subscriptions", icon: <SubscriptionsRounded sx={{ ml: 2 }} />, label: "Subscription" },
        { path: "/home/campaign-workflow", icon: <SchemaRounded sx={{ ml: 2 }} />, label: "Workflow Stats" },
    ] : [
        { path: "/home", icon: <DashboardOutlined sx={{ ml: 2 }} />, label: "Dashboard" },
        { path: "/home/leads", icon: <LeaderboardOutlined sx={{ ml: 2 }} />, label: "Leads" },
        { path: "/home/campaigns", icon: <CampaignOutlined sx={{ ml: 2 }} />, label: "Campaigns" },
        { path: "/home/followUps", icon: <EventRepeatOutlined sx={{ ml: 2 }} />, label: "Follow Ups" },
        { path: "/home/templates", icon: <EmailOutlined sx={{ ml: 2 }} />, label: "Templates" },
        { path: "/home/attachments", icon: <AttachEmailOutlined sx={{ ml: 2 }} />, label: "Attachments" },
        { path: "/home/analytics", icon: <AnalyticsOutlined sx={{ ml: 2 }} />, label: "Analytics" },
        // { path: "/home/alerts", icon: <NotificationsActiveOutlined sx={{ml:3}}/>, label: "Alerts" },
        { path: "/home/business", icon: <BusinessOutlined sx={{ ml: 2 }} />, label: "Business Info" },
        { path: "/home/subscription", icon: <CardMembershipOutlined sx={{ ml: 2 }} />, label: "Subscription" },
        //{ path: "/home/settings", icon: <SettingsOutlined sx={{ml:3}}/>, label: "Settings" },
        { path: "/home/helpCenter", icon: <HelpCenterOutlined sx={{ ml: 2 }} />, label: "Help Center" },
    ];
    return (
        <Sidebar
            style={{
                height: '100%',
                top: 'auto',
                borderRight: `1px solid ${theme.palette.divider}`,
                background: theme.palette.background.paper,
            }}
            breakPoint="md"
            collapsed={collapsed}
            toggled={toggled}
            onToggle={() => setToggled(false)} //close on outside click (mobile)
            backgroundColor={theme.palette.background.paper}
            collapsedWidth="7rem"
        >

            <Menu
                menuItemStyles={{
                    button: ({ active }) => ({
                        borderRadius: 10,
                        margin: '6px 12px',
                        padding: '10px 12px',
                        backgroundColor: active ? theme.palette.secondary.main + '22' : 'transparent',
                        color: active ? theme.palette.primary.main : theme.palette.text.primary,
                        transition: 'background-color 150ms ease',
                        '&:hover': {
                            backgroundColor: theme.palette.secondary.main + '33'
                        }
                    })
                }}
                style={{ paddingBottom: '70px' }}
            >
                {menuItems.map(({ path, icon, label }) => (
                    <Box key={path}>
                        <MenuItem active={location.pathname === path} component={<Link to={path} />} icon={icon}>
                            <Typography sx={{ pl: 4, fontWeight: location.pathname === path ? 700 : 500 }}>{label}</Typography>
                        </MenuItem>
                        {collapsed &&
                            (<Typography
                                variant="body2"
                                sx={{
                                    textAlign: 'center',
                                    //backgroundColor:location.pathname===path? theme.palette.secondary.main + '22' : '',
                                    color: location.pathname === path ? theme.palette.primary.main : '',
                                }}
                            >
                                {label}
                            </Typography>)
                        }
                    </Box>
                ))}

            </Menu>
        </Sidebar>
    );
}

